export default __webpack_public_path__ + "static/media/heart.ae427a9b.svg";